import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND } from '../kit/tokens';
import { Home } from 'lucide-react';

// Shared layout for public, unauthenticated auth pages (verify-email,
// forgot-password, reset-password). Copied out of VerifyEmailPage's Shell
// (ticket 140) — VerifyEmailPage keeps its own local copy untouched.
export default function AuthShell({ children, testId, tagline = 'Secure link' }) {
  return (
    <div className="min-h-screen flex" style={{ background: '#faf7f2' }}>
      <div className="hidden lg:flex lg:w-5/12 relative overflow-hidden" style={{ background: `linear-gradient(160deg, ${BRAND.navyDeep} 0%, ${BRAND.navy} 60%, ${BRAND.navyLight} 100%)` }}>
        <div className="absolute inset-0 opacity-40" style={{ backgroundImage: 'radial-gradient(circle at 30% 20%, rgba(141,198,63,0.35) 0%, transparent 45%)' }} />
        <div className="relative z-10 flex flex-col justify-between p-12 text-white">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-white"><Home size={14} /> BrokerForYou</Link>
          <div>
            <img src="/assets/tcl-logo-white.png" alt="Top Choice Lending" className="h-14" />
            <h1 className="font-serif text-5xl font-semibold mt-8">Almost <span className="text-brand-accent-soft">there</span>.</h1>
          </div>
          <div className="text-xs text-white/40">{tagline}</div>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md" data-testid={testId}>{children}</div>
      </div>
    </div>
  );
}
